export const enum TwoFactorAuthError {
    TWO_FA_CODE_IS_EMPTY = 'TWO_FA_CODE_IS_EMPTY',
    TWO_FA_CODE_IS_WRONG = 'TWO_FA_CODE_IS_WRONG',
    TWO_FA_CODE_ERROR    = 'TWO_FA_CODE_ERROR'
}

export const TWO_FACTOR_AUTH_ERRORS: TwoFactorAuthError[] = [
    TwoFactorAuthError.TWO_FA_CODE_IS_EMPTY,
    TwoFactorAuthError.TWO_FA_CODE_IS_WRONG,
    TwoFactorAuthError.TWO_FA_CODE_ERROR
];
